<form [formGroup]="form">
    <rask-datepicker
        class="col-4"
        [label]="texts.periodsattPeriod"
        aid="periodsattPeriodDatum"
        formControlName="periodsattPeriod"
        [minDate]="periodsattPeriodMinDate"
        [onlyMonths]="true"
        [disabled]="!canSetPeriod"
        (change)="periodsattPeriodChanged($event)">
    </rask-datepicker>
</form>